export enum DemoNegotiationState {
  ESTIMATED = 'estimated',
  SUGGESTED = 'suggested',
}
